import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'
import { colors, media } from '../styles/vars'
import arrowDownImg from '../static/images/icons/arrow_down.png'

const upDown = keyframes`
0%{
    transform:translate3d(0, -2px, 0);
}
100%{
    transform:translate3d(0, 2px, 0);
}
`
const upSideDown = keyframes`
0%{
    transform:translate3d(0, -2px, 0) rotate(180deg);
}
100%{
    transform:translate3d(0, 2px, 0) rotate(180deg);
}
`
const Container = styled.div`
position:relative;
text-align:center;
direction:rtl;
height:90px;
cursor:pointer;
`
const Button = styled.button`
position:relative;
width: 26px;
height: 26px;
border-radius: 50%;
border-width:3px;
border-style:solid;
transition:border-color .2s, background-color .2s;
cursor:pointer;
${
    media.desktop`
    width:32px;
    height:32px;
    `
    }
`
const DynamicButton = styled(Button) `
background-color: ${props => props.active ? colors.lightblue : colors.white};
border-color: ${props => props.active ? colors.black : colors.white};
`
const YearText = styled.h2`
color:${colors.white};
transition:font-size .4s;
`

const DynamicYearText = styled(YearText) `
font-weight: ${props => props.active ? '700' : '400'};
font-size: ${props => props.active ? '7rem' : '6rem'};
`
const Arrow = styled.img`
max-width:60%;
position:absolute;
top:0;
right:0;
bottom:0;
left:0;
margin:auto;
will-change:transform;
animation-name:${upDown};
animation-duration: .6s;
animation-direction:alternate-reverse;
animation-iteration-count:infinite;
animation-timing-function: linear;
${
    media.desktop`
    animation-name:${upSideDown};
    `
    }
`
const DynamicArrow = styled(Arrow) `
display: ${props => props.active ? 'block' : 'none'} !important;
`
class TimelineItem extends Component {
    constructor(props) {
        super();
        this.handleClick = this.handleClick.bind(this);
    }
    componentDidMount(){
        this.props.onLoad(this.props.idx, this.node)
    }
    handleClick() {
        this.props.onClick(this.props.idx);
    }
    render() {
        return (
            <Container innerRef={node => this.node = node} onClick={this.handleClick}>
                <div>
                    <DynamicButton active={this.props.active}>
                        <DynamicArrow src={arrowDownImg} active={this.props.active} />
                    </DynamicButton>
                    <DynamicYearText active={this.props.active}>{this.props.year}</DynamicYearText>
                </div>
            </Container>
        )
    }
}

export default TimelineItem;


// WEBPACK FOOTER //
// ./src/components/TimelineItem.jsx